/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Input from "../../../components/Form/Input";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({ open, setOpen, saveInfo, Areas }) {
  const [values, setyvalues] = React.useState({
    nombre: "",
    correo: "",
    telefono: "",
    areas_id: "",
    direccion: "",
    fecha_inicio: "",
  });

  const handleClose = () => {
    cleanValues();
    setOpen(false);
  };

  const save = () => {
    const arraySend = {
      nombre: values.nombre,
      correo: values.correo,
      telefono: values.telefono,
      areas_id: values.areas_id,
      direccion: values.direccion,
      fecha_inicio: values.fecha_inicio,
    };

    saveInfo(arraySend);
  };

  const cleanValues = () => {
    setyvalues({
      nombre: "",
      correo: "",
      telefono: "",
      areas_id: "",
      direccion: "",
      fecha_inicio: "",
    });
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{ position: "relative" }}
          style={{
            background: "#fff",
            padding: "0px !important",
          }}
        >
          <Toolbar
            style={{
              background: "#363335",
              width: "100%",
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Nuevo Empleado
            </Typography>
            <Button autoFocus color="inherit" onClick={save}>
              Guardar
            </Button>
          </Toolbar>
          <div className="px-5 pb-5 mt-3">
            <Input
              label="Nombre"
              name="name"
              value={values.nombre}
              onChange={(e) => {
                setyvalues({ ...values, nombre: e.target.value });
              }}
            />
            <Input
              label="Correo"
              name="name"
              value={values.correo}
              onChange={(e) => {
                setyvalues({ ...values, correo: e.target.value });
              }}
            />
            <Input
              label="Telefono"
              name="name"
              value={values.telefono}
              onChange={(e) => {
                setyvalues({ ...values, telefono: e.target.value });
              }}
            />
            <Input
              label="Direccion"
              name="name"
              value={values.direccion}
              onChange={(e) => {
                setyvalues({ ...values, direccion: e.target.value });
              }}
            />
            <Input
              label="Fecha de inicio"
              name="name"
              value={values.fecha_inicio}
              onChange={(e) => {
                setyvalues({ ...values, fecha_inicio: e.target.value });
              }}
            />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Selecciona un area
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={values.areas_id}
                label="Selecciona un area"
                onChange={(e) => {
                  setyvalues({ ...values, areas_id: e.target.value });
                }}
              >
                {Areas.map((item) => {
                  return <MenuItem value={item.value}>{item.label}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </div>
        </AppBar>
      </Dialog>
    </div>
  );
}
